import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast:
                        "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                    description: "group-[.toast]:text-muted-foreground",
                    actionButton:
                        "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
                    cancelButton:
                        "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
                },
            }}
            style={{
                // Custom dark theme styles
                // @ts-ignore
                "--normal-bg": "#1a1a1b",
                "--normal-border": "rgba(255,255,255,0.1)",
                "--normal-text": "#E8E6E1",
                "--success-bg": "#052e16",
                "--success-border": "#22c55e",
                "--success-text": "#22c55e",
                "--error-bg": "#450a0a",
                "--error-border": "#ef4444",
                "--error-text": "#ef4444",
            }}
            {...props}
        />
    );
};

export { Toaster, toast };
